<template>
  <div>
    <!-- 装箱信息 -->
    <el-dialog :title="$t('message.packingInformation')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1708px" center>
      <div class="content">
        <!-- 当前箱号 -->
        <div class="boxNum">
          {{ $t("message.presentBoxNum") }}:<span>{{ boxDetail.box_no }}</span>
        </div>
        <div class="table">
          <ol>

            <li class="flex05">
              NO
            </li>
            <li class="flex05">

            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 交易号/物流号 -->
            <li class="flex2">{{ $t("message.transactionNumberLogisticsNumber") }}</li>
            <!-- 其他箱已装箱数 -->
            <li>{{ $t("message.otherBoxesHavePackedNum") }}</li>
            <!--本箱装货数  -->
            <li class="flex25">{{ $t("message.quantityOfCargoInThisCase") }}</li>
            <!-- 移箱数量 -->
            <li class="flex25" v-if="boxStatus == '装箱中'">{{ $t("message.moveBoxQuantity") }}</li>
          </ol>
          <ul v-for="(item, index) in boxDetail.list" :key="index">
            <li class="flex05">
              {{ index + 1 }}
            </li>
            <li class="flex05">
              <el-checkbox v-model="item.checked"></el-checkbox>
            </li>
            <!-- 订单号 -->
            <li class="flex15">
              <div>
                <p>
                  <el-link :href="'/#/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" type="primary">{{
                    item.order_sn
                  }}</el-link>
                </p>
              </div>
            </li>
            <!--  番号-->
            <li class="flex05">
              {{ item.sorting }}
            </li>
            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="item.link.goods_url" target="_blank" slot="reference">
                      <img :src="item.pic" alt="" style="width: 60px; height: 60px" />
                    </a>
                  </el-popover>
                </div>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 交易号/物流号 -->
            <li class="flex2">
              <div>
                <div class="template" v-for="(purchase, purchaseIndex) in item.list" :key="purchaseIndex">
                  <p>JY:{{ purchase.purchase_no }}</p>
                  <p v-for="(express_no, express_index) in purchase
                    .express_no" :key="express_index">
                    WL{{ express_index + 1 }}：{{ express_no }}
                  </p>
                </div>
              </div>
            </li>
            <!-- 其他箱已装箱数 -->
            <li>
              {{ item.other_box_total_num }}
            </li>
            <!-- 本箱已装箱数 -->
            <li class="flex25">
              <div class="template">
                <div class="row" v-for="(purchase, purchaseIndex) in item.list" :key="purchaseIndex">
                  <span>
                    JY{{ purchaseIndex + 1 }}:
                    {{ purchase.purchase_no }}
                  </span>
                  <!-- 取消装箱数 -->
                  <span>
                    {{ purchase.box_num }}
                  </span>
                </div>
              </div>
            </li>
            <!--  移箱数量-->
            <li class="flex25" v-if="boxStatus == '装箱中'">
              <div class="template">
                <div class="row" v-for="(purchase, purchaseIndex) in item.list" :key="purchaseIndex">
                  <span>
                    JY{{ purchaseIndex + 1 }}:
                    {{ purchase.purchase_no }}
                  </span>
                  <!-- 取消装箱数 -->
                  <span>
                    <el-input v-model="purchase.cancelEncasementNum" onfocus="this.select()"
                      @input="maxNum(index, purchaseIndex)" onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      size="small"></el-input>
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 箱子列表 -->
      <div class="box" v-if="boxStatus == '装箱中'">
        <!-- 箱子列表 -->
        <div v-for="(item, index) in boxList" :key="index" class="boxList">

          <!-- 箱子列表 -->
          <div class="list">
            <div v-for="(box, boxIndex) in item.list" :key="boxIndex" class="box-item">
              <div class="checkbox">
                <el-checkbox v-model="box.checked" @change="checkedChange(index, boxIndex)"></el-checkbox>
              </div>
              <div class="box-detail">
                <div class="row">
                  <div class="key">NO：</div>
                  <div class="value" style="color: #B4272D;font-weight: bold;">{{ box.box_no }}</div>
                </div>
                <!-- 实重 -->
                <div class="row">
                  <div class="key">{{ $t("message.actualWeightS") }}：</div>
                  <div class="value">{{ box.weight }}KG</div>
                </div>
                <!-- 尺寸 -->
                <div class="row">
                  <div class="key">{{ $t("message.size") }}：</div>
                  <div class="value">{{ box.attr }}cm</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 确认移箱 -->
        <el-button type="primary" @click="moveOut" v-if="boxStatus == '装箱中' && isAuth(248)">
          {{ $t("message.confirmationOfBoxMoving") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    move_sn: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      boxStatus: '',
      box_id: '',
      to_box_id: '',
      boxList: [],
      boxDetail: {},
    };
  },

  methods: {
    // 获取箱子详情
    getBoxDetail() {
      let datas = {
        box_id: this.box_id,
      }
      this.$api.inventoryTransferApi.boxDetail(datas).then((res) => {
        res.data.list.forEach((item) => {
          item.checked = false
          item.list.forEach((items) => {
            items.cancelEncasementNum = items.box_num
          })
        })
        this.boxDetail = res.data
      });
    },
    // 移箱
    moveOut() {
      let datas = {
        from_box_id: this.box_id,
        to_box_id: this.to_box_id,
        list: [],
      };
      //   移箱数据
      this.boxDetail.list.forEach((item) => {
        item.list.forEach((items) => {
          if (items.cancelEncasementNum > 0 && item.checked) {
            datas.list.push({
              order_purchase_id: items.order_purchase_id,
              num: items.cancelEncasementNum,
            });
          }
        });
      });
      if (datas.list.length == 0) {
        this.$message.error("请选择要移箱的商品");
        return;
      }
      this.$api.inventoryTransferApi.moveBoxGoods(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$store.dispatch("transferOrdeBoxList", { move_sn: this.move_sn, });
      });
    },
    //装箱数最大数
    maxNum(index, purchaseIndex) {
      let item =
        this.boxDetail.list[index].list
      if (item.cancelEncasementNum > item.box_num) {
        item.cancelEncasementNum = item.box_num;
        this.$message.error("移箱数量不能大于本箱装货数");
        this.$forceUpdate();
      }
    },
    // 选择箱子
    checkedChange(index, boxIndex) {
      this.boxList.forEach((item) => {
        item.list.forEach((items) => {
          items.checked = false
        })
      })
      this.boxList[index].list[boxIndex].checked = true
      this.to_box_id = this.boxList[index].list[boxIndex].id
      this.$forceUpdate()
    },
    // 获取全部箱子
    getBoxList() {
      let data = {
        move_sn: this.move_sn,
      }
      this.$api.inventoryTransferApi.boxList(data).then(res => {
        res.data.forEach(item => {
          item.list.forEach(box => {
            box.checked = false
          })
        })
        this.boxList = res.data.filter(item => item.status_name == '装箱中')
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;

  .boxNum {
    margin-bottom: 24px;

    span {
      font-weight: bold;
    }
  }

  .table {

    ol {
      height: 50px;
    }


    .template {
      width: 100%;
      text-align: left;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .flex25 {
      flex: 2.5;
    }

    .row {
      display: flex;
      margin-bottom: 5px;
      line-height: 32px;

      &:nth-last-child(1) {
        margin: 0;
      }

      span {
        flex: 3;

        &:nth-child(2) {
          flex: 1;
        }
      }
    }
  }
}

.box {
  border-radius: 8px;
  margin: 24px 15px 0;

  .boxList {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 0 8px;

    .box-item {
      background: #FFFFFF;
      display: flex;
      align-items: center;
      padding: 12px;
      border: 1px solid #DCDFE6;
      margin: 12px 12px 0 0;
      border-radius: 4px;

      .checkbox {
        width: 20px;
        height: 100%;
        margin-top: 10px;
      }

      .box-detail {
        margin-left: 12px;

        .row {
          display: flex;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }


    }
  }
}
</style>